import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';
interface DownloadInvoicePayload {
  appointmentId: string;
  invoiceId: string;
}
const downloadInvoiceApi = createAsyncThunk(
  'downloadInvoiceApi',
  async (payload: DownloadInvoicePayload, { rejectWithValue }) => {
    try {
      const { appointmentId, invoiceId } = payload;
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = BILLING_ROUTES.INVOICE.download;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ appointmentId, invoiceId }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch report details');
      }

      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to download invoice');
    }
  }
);

export default downloadInvoiceApi;
